import { doc, getDoc } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import Subscription from "../../models/Subscription";
import AI from "../../models/AI";

async function getAIBySubscriptionId(
  subscriptionId: string
): Promise<AI | null> {
  try {
    const db = firestore;

    const subscriptionDocRef = await getDoc(
      doc(db, FirestoreCollections.subscriptions, subscriptionId)
    );

    if (!subscriptionDocRef.exists()) {
      return null;
    }

    const subscription = Subscription.fromFirestore(subscriptionDocRef);

    const idAi = subscription.idAi;

    const queryResult = await getDoc(doc(db, FirestoreCollections.ai, idAi));

    if (!queryResult.exists()) {
      return null;
    }

    return AI.fromFirestore(queryResult);
  } catch (e) {
    console.log("error: ", e);
    throw new GetAIBySubscriptionIdFailure();
  }
}

export class GetAIBySubscriptionIdFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getAIBySubscriptionId;
